// ─────────────────────────────────────────────────────────────
// DATOS EDITABLES DE ATENTO — todo el contenido de contacto
// se configura aquí antes de publicar.
// ─────────────────────────────────────────────────────────────

export const site = {
  name: "ATENTO",
  fullName: "ATENTO. Gabinete de Psicopedagogía",
  descriptor: "Gabinete de Psicopedagogía",
  owner: "Lidia Montiel",
  role: "Orientadora educativa y pedagoga",
  slogan: "Comprender para avanzar",
  city: "Chiclana de la Frontera, Cádiz",

  // Teléfono y WhatsApp (ya configurados)
  phoneDisplay: "624 50 74 03",
  phoneHref: "tel:+34624507403",
  whatsappNumber: "34624507403",
  whatsappMessage:
    "Hola Lidia, me gustaría solicitar información sobre los servicios de ATENTO.",

  // Horario y zonas de atención
  schedule: "Lunes, todo el día. De martes a viernes, por la tarde. Con cita previa.",
  areas: "Atiendo en persona a familias de Chiclana de la Frontera, San Fernando, Puerto Real, Conil, Barbate y Cádiz.",

  // Instagram (ya configurado)
  instagramHandle: "@atento_psicopedagogia",
  instagramUrl: "https://www.instagram.com/atento_psicopedagogia",

  email: "gabinete@atentopsicopedagogia.es",
  address: "C.C. La plaza. Planta 1, local 23. Calle Ayala",
};

export const whatsappLink = `https://wa.me/${site.whatsappNumber}?text=${encodeURIComponent(
  site.whatsappMessage,
)}`;

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -76, duration: 1.2 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

export const prefillMotivo = (texto) => {
  window.dispatchEvent(new CustomEvent("atento:prefill", { detail: texto }));
  scrollToId("contacto");
};
